import type { Currency, CountryCode } from '../types';

import { formatMoney as formatMoneyCanonical } from '@/lib/money';

/** Converged onto the canonical app-wide formatter: "TZS 1,500,000". */
export function formatMoney(amount: number, currency: Currency): string {
  return formatMoneyCanonical(amount, currency);
}

/** Compact form for stat cards (e.g. "TZS 1.2M"). */
export function formatMoneyCompact(amount: number, currency: Currency): string {
  return formatMoneyCanonical(amount, currency, { compact: true });
}

export function formatDate(iso: string): string {
  // A DATE-ONLY value ("2026-09-30") is a calendar date, not an instant:
  // new Date() would parse it as UTC midnight and toLocaleDateString would
  // render it a day EARLY in any UTC-negative timezone (statutory due dates
  // showed "Sep 29" for a Sep 30 deadline). Construct it as a local date so
  // the calendar date survives; real timestamps keep instant semantics.
  const dateOnly = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso);
  const d = dateOnly
    ? new Date(Number(dateOnly[1]), Number(dateOnly[2]) - 1, Number(dateOnly[3]))
    : new Date(iso);
  return d.toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
}

export const COUNTRY_LABEL: Record<CountryCode, string> = {
  TZ: 'Tanzania',
  KE: 'Kenya',
  RW: 'Rwanda',
};

export const COUNTRY_FLAG: Record<CountryCode, string> = {
  TZ: '🇹🇿',
  KE: '🇰🇪',
  RW: '🇷🇼',
};
